<div class="container-center">

    <div class="boxL" style="width: 100%;">
        <div>
            
            <app-logo class="logo"></app-logo>

            <span class="line_box"></span>

            <img src="./404-az.png" alt="404 - Not Found" style="width: 200px;margin: 50px auto 10px auto;" />
            <span style="width: 100%;text-align:center;color: #94b4cb;" class="title">Página não encontrada</span>

            <p class="p" style="width: 100%;text-align:center; margin-top: 50px;">
                <a (click)="voltar()"
                    style="cursor: pointer; background-color: #d9e6ef; padding: 10px 20px; border-radius: 5px;">
                    <i class="pi pi-arrow-left" style="font-size: 1rem"></i> Voltar
                </a>
            </p>

        </div>

    </div>
    
    <!-- <div class="boxR banner-radius" style="display: none;">
        <span>
            <div class="icon-fornecedores"></div>
            <div>Faça parte da rede de fornecedores do ISGH.</div>
            <div class="bigline_box"></div>
        </span>
    </div> -->

</div>